import React from "react";
import styled from "styled-components";

interface NoImagePlaceholderProps {
  /** 표시할 안내 문구 (기본: 이미지 없음) */
  text?: string;
  /** 아이콘 크기 (px, 기본 40) */
  iconSize?: number;
  /** 박스 모서리 반경 (px, 기본 12). 부모가 이미 클리핑하는 경우 맞춰서 조정 */
  radius?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * 이미지 없음 상태 플레이스홀더.
 * 밝은 회색 라운드 박스 + 아웃라인 photo 아이콘 + 안내 문구.
 */
const NoImagePlaceholder: React.FC<NoImagePlaceholderProps> = ({
  text = "이미지 없음",
  iconSize = 40,
  radius = 12,
  className,
  style,
}) => {
  return (
    <PlaceholderBox className={className} style={style} radius={radius}>
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 40 40"
        fill="none"
        stroke="#c4c7ce"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {/* 둥근 사각 프레임 */}
        <rect x="5" y="7" width="30" height="26" rx="4" />
        {/* 좌상단 작은 원 (해) */}
        <circle cx="14" cy="16" r="3" />
        {/* 하단 산(삼각형) */}
        <path d="M9 30l8-9 6 6 4-4 4 5" />
      </svg>
      {text && <PlaceholderText>{text}</PlaceholderText>}
    </PlaceholderBox>
  );
};

const PlaceholderBox = styled.div<{ radius: number }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eef0f2;
  border-radius: ${({ radius }) => radius}px;
`;

const PlaceholderText = styled.span`
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.2;
  color: #9aa0a6;
`;

export default NoImagePlaceholder;
